<template>
  <div id="app">
    <!-- <layout-navigation/> -->
    <router-view/>
  </div>
</template>

<script>
// import BaseSpinner from './components/global/BaseSpinner'
// import LayoutNavigation from './components/layout/LayoutNavigation'
import { threadsRef } from './firebase/'
import Vue from 'vue'
import VueChatScroll from 'vue-chat-scroll'
Vue.use(VueChatScroll)

export default {
  name: 'App',
  data () {
    return {
      threadsRef: {}
    }
  },
  components: {
  // LayoutNavigation
  },
  mounted () {
    this.$firebase.auth().onAuthStateChanged()
  }
}
</script>

<style lang="scss">
#app {
  min-height: 100vh;
  color: var(--dark);
  background-color: var(--light);
}

</style>
